module.exports = { 
    STORE_KEY: 'a56z0fzrNpl^2', 
    BASE_API: (parseInt(process.env.REACT_APP_SISTEMA) === 1 ? process.env.REACT_APP_BACKEND_URL_UNIFORMES : process.env.REACT_APP_BACKEND_URL_TABLETAS),
    LABELTEXT: (parseInt(process.env.REACT_APP_SISTEMA) === 1 ? process.env.REACT_APP_LABELTEXT_UNIFORMES.toString() : process.env.REACT_APP_LABELTEXT_TABLETAS.toString()),
    LABELTEXT_S: (parseInt(process.env.REACT_APP_SISTEMA) === 1 ? process.env.REACT_APP_LABELTEXT_S_UNIFORMES.toString() : process.env.REACT_APP_LABELTEXT_S_TABLETAS.toString()),
    RECAPTCHAKEY: process.env.REACT_APP_CAPTCHA,
    PROPERTYID: process.env.PROPERTYID,
    WIDGETID: process.env.WIDGETID,
    ENTORNO: process.env.REACT_APP_ENTORNO,
    VERSION: 'v5.20260511.1',
    VERSIONMIN: 'v5.20260511.1',
    COLOR: { 
        ORANGE: '#C50', 
        DARKBLUE: '#0F3274', 
        LIGHTBLUE: '#6EA8DA', 
        DARKGRAY: '#999', 
    }, 
};